import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css' // Optional - for icons
import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Create Vuetify instance
const vuetify = createVuetify({
  components: {
    ...components,
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: 'light', // Set default theme (can be 'dark' or 'light')
    themes: {
      light: {
        // Define the light theme colors
        colors: {
          primary: '#1976D2', // Blue (primary color)
          secondary: '#424242', // Grey (secondary color)
          accent: '#82B1FF', // Light blue (accent color)
          error: '#FF5252', // Error color
          info: '#2196F3', // Info color
          success: '#4CAF50', // Success color
          warning: '#FF9800', // Warning color
          'breadcrumbs-disabled': '#C358FAFF', //override breadcrumb color active
        },
        // You can also configure other properties, like darken and lighten modifiers
        dark: false, // false for light theme, true for dark theme
      },
      dark: {
        // Define the dark theme colors
        colors: {
          primary: '#BB86FC',
          secondary: '#03DAC5',
          accent: '#3700B3',
          error: '#CF6679',
          info: '#6200EE',
          success: '#03DAC6',
          warning: '#FFB300',
        },
      },
    },
  },
})

// Export vuetify instance for usage
export default vuetify
